import { COLORS, LAYOUT, TYPOGRAPHY, LOADING_STYLES } from '../../constants';

export const styles = {
  // Page container with gradient background
  pageContainer: {
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.primary}08 0%, ${COLORS.primary}02 100%)`,
    paddingTop: LAYOUT.spacing.xl,
    paddingBottom: LAYOUT.spacing.xxxl
  },

  // Main container
  container: {
    maxWidth: 1400,
    margin: '0 auto',
    padding: `0 ${LAYOUT.spacing.xl}px`
  },

  // Header with icon
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.lg,
    marginBottom: LAYOUT.spacing.xxxl,
    padding: LAYOUT.spacing.xl,
    background: 'linear-gradient(135deg, #CE1126 0%, #9d0d1d 100%)',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(206, 17, 38, 0.2)',
    color: '#fff'
  },

  headerIcon: {
    width: 64,
    height: 64,
    background: 'rgba(255, 255, 255, 0.15)',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },

  title: {
    ...TYPOGRAPHY.heading1,
    color: '#fff',
    fontWeight: 700,
    fontSize: 36,
    margin: 0,
    lineHeight: 1.2
  },

  subtitle: {
    ...TYPOGRAPHY.body,
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: 16,
    margin: `${LAYOUT.spacing.xs}px 0 0 0`,
    fontWeight: 400
  },

  // Content grid layout
  contentGrid: {
    display: 'grid',
    gridTemplateColumns: '400px 1fr',
    gap: LAYOUT.spacing.xl,
    alignItems: 'start'
  },

  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.lg
  },

  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.lg
  },

  // Profile image
  profileImage: {
    width: '140px',
    height: '140px',
    borderRadius: LAYOUT.borderRadius.full,
    objectFit: 'cover',
    border: `4px solid ${COLORS.primary}`,
    backgroundColor: COLORS.grayLight,
    boxShadow: '0 4px 16px rgba(206, 17, 38, 0.15)'
  },

  // Loading styles
  loadingContainer: LOADING_STYLES.container,
  loadingSpinner: LOADING_STYLES.spinner,
  loadingText: LOADING_STYLES.text
};